module.exports = __webpack_public_path__ + "static/media/note.a6a68830.mp3";